import { FC, memo, useMemo } from 'react';
import classNames from 'classnames';
import { Typography } from 'antd';

import { RowPropsT } from 'models';
import { useAppSelector } from 'hooks';
import { language } from 'utils';

export const PrimaryMarketProjectParams = () => {
	const project = useAppSelector((state) => state.primaryMarket.item);

	const params = useMemo(
		() =>
			project.params
				?.filter((item) => item.language === language)
				.sort((a, b) => {
					return +a.orderPosition - +b.orderPosition;
				}),
		[project.params],
	);

	return (
		<div className="primaryItem__params">
			<div className="primaryItem__paramsColumn">
				{params.slice(0, Math.ceil(params.length / 2)).map((item) => {
					return (
						<DetailsRow
							key={item.title}
							title={item.title}
							value={item.description}
							pledgeKey={item.pledgeKey}
						/>
					);
				})}
			</div>

			<div className="primaryItem__paramsColumn">
				{params.slice(Math.ceil(params.length / 2), params.length).map((item) => {
					return (
						<DetailsRow
							key={item.title}
							title={item.title}
							value={item.description}
							pledgeKey={item.pledgeKey}
						/>
					);
				})}
			</div>
		</div>
	);
};

const DetailsRow: FC<RowPropsT> = memo(({ title, value, pledgeKey }) => {
	return (
		<div
			className={classNames('primaryItem__detailRow', {
				'primaryItem__detailRow--red':
					(pledgeKey === 'loanStatus' &&
						(value.toString().toLowerCase() === 'in recovery' ||
							value.toString().toLowerCase() === 'išieškoma')) ||
					pledgeKey === 'note',
			})}
		>
			<Typography.Text className="primaryItem__detailRowTitle">{title}</Typography.Text>
			<Typography.Text>{value}</Typography.Text>
		</div>
	);
});
